export default __webpack_public_path__ + "static/Dashboard-2@2x-bc4381e688de8688b9d73b6a968a3dbf.svg";